import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {__} from "~/ts/library/Translate";
import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import {computed} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";



import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "RequestRateButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let {client, showFreeDialogForSite} = useTextareaComponent();

let isCanRequestRate = computed(() => {
    return OperatorAccountStore.checkAccess(OperatorAccountStore.data.value.accessRights.canRequestRate, client.value.siteId);
});

async function requestRate() {
    if (!showFreeDialogForSite()) {
        let p: OperatorApplicationApi.OperatorMessageRequestRateOpenApiModel = {
            username: client.value.username
        };
        let result = await (new OperatorApiRequest({
            url: "/message/requestRate",
            p
        })).send();
        result.showMessageOnError();
    }
}

return (_ctx: any,_cache: any) => {
  return (_unref(isCanRequestRate))
    ? (_openBlock(), _createBlock(OperatorApplicationDialogTextareaButton, {
        key: 0,
        icon: "star",
        tooltip: _unref(__)('Предложить оставить отзыв'),
        onClick: requestRate
      }, null, 8, ["tooltip"]))
    : _createCommentVNode("", true)
}
}

})